export default __webpack_public_path__ + "static/media/header_mobile_menu.83256f05.svg";